import styled from '@emotion/styled'
import tw from 'twin.macro'

export const HeroGrid = styled.div`
  ${tw`
    grid
    grid-cols-1
    lg:grid-cols-6
    lg:gap-24
  `}
`

export const HeroIntro = styled.div`
  ${tw`
    flex 
    flex-col
    text-left
    sm:text-center
    mt-12
  `}
`

export const Illustration = styled.div`
  ${tw`
    mt-6
    mb-8
  `}
`

export const HeroCenter = styled.div`
  ${tw`
    flex 
    flex-col
    justify-center
    text-center
    col-span-2
    row-start-1
  `}
`

export const TextBlock = styled.div`
  ${tw`
    col-span-2
    pt-12
    text-left
    sm:text-center
    lg:text-left
    overflow-hidden
    relative
  `}
  &.block-1 {
    ${tw`
      row-start-2
      lg:col-start-1
      lg:row-start-1
      lg:text-right
    `}
  }
  &.block-2 {
    ${tw`
      row-start-3
      lg:col-start-5
      lg:row-start-1
    `}
  }
`

export const Title = styled.div`
  ${tw`
    text-xl
    font-medium
    tracking-tight
    sm:text-2xl
  `}
  color: #3FC5EA;
`

export const Description = styled.div`
  ${tw`
    mt-6
    h-80
    max-w-3xl
    mx-auto
    text-purple-300
    text-lg
    leading-7
  `}
`
